import store from './Vuex/index'

export const ifAuthenticated = (to, from, next) => {
    if(to.name === 'order' && !localStorage.getItem('logged')) {
        localStorage.setItem('afterLoginRedirect',to.fullPath);
    }
    localStorage.getItem('logged') ?
        next() :
        next('/');

}
export const ifNotAuthenticated = (to, from, next) => {
    localStorage.getItem('logged') ?
        next('/') :
        next();
}
export const cartCount = (to, from, next) => {
    store.state.cart.totalCount > 0 ?
        next() :
        next('/')
}
